// extracted by mini-css-extract-plugin
export default {"gameCommentary":"GameCommentary_gameCommentary__EdUk1","winnerName":"GameCommentary_winnerName__cNYTX","mediaLink":"GameCommentary_mediaLink__3zGch"};